/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Serializer for verifying an email verification token.
 * @export
 * @interface VerifyTokenRequest
 */
export interface VerifyTokenRequest {
    /**
     * 
     * @type {string}
     * @memberof VerifyTokenRequest
     */
    token: string;
}

/**
 * Check if a given object implements the VerifyTokenRequest interface.
 */
export function instanceOfVerifyTokenRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "token" in value;

    return isInstance;
}

export function VerifyTokenRequestFromJSON(json: any): VerifyTokenRequest {
    return VerifyTokenRequestFromJSONTyped(json, false);
}

export function VerifyTokenRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): VerifyTokenRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'token': json['token'],
    };
}

export function VerifyTokenRequestToJSON(value?: VerifyTokenRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token': value.token,
    };
}

